import React, { useEffect, useRef } from "react";
import * as echarts from "echarts";
import "echarts-liquidfill";

const LiquidChart = ({ value, color }) => {
    const chartRef = useRef(null);

    useEffect(() => {
        const chartInstance = echarts.init(chartRef.current);

        const option = {
            series: [
                {
                    type: "liquidFill",
                    radius: "100%",
                    data: [value],
                    label: {
                        normal: {
                            formatter: `${Math.round(value * 100)}%`,
                            color: "#ffffff",
                            fontSize: 14,
                            fontWeight: "700",
                        },
                    },
                    color: [
                        {
                            type: "linear",
                            x: 0,
                            y: 1,
                            x2: 0,
                            y2: 0,
                            colorStops: [
                                { offset: 1, color: color },      
                                { offset: 0, color: echarts.color.lift(color, 0.3) }, 
                            ],
                            global: false,
                        },
                    ],
                    outline: {
                        show: false,
                    },
                    backgroundStyle: {
                        color: "#f5f5f5",
                    },
                },
            ],
        };

        chartInstance.setOption(option);

        return () => {
            chartInstance.dispose();
        };
    }, [value, color]);

    return <div ref={chartRef} style={{ width: 65, height: 65 }} />;
};

export default LiquidChart;
